"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A way to group {@link Task}s
 */
var Milestone = /** @class */ (function () {
    /**
     * @param name - The milestone name
     * @param url - The URL to this milestone (directly usable in an `<a>` href)
     * @param description - The milestone description
     * @param start - A start date for the milestone
     * @param due - A due date for the milestone
     */
    function Milestone(name, url, description, start, due) {
        this.name = name;
        this.url = url;
        this.description = description;
        this.start = start;
        this.due = due;
        /**
         * The paginated list of {@link Task}s in the milestone
         */
        this.tasks = null;
    }
    return Milestone;
}());
exports.Milestone = Milestone;
//# sourceMappingURL=Milestone.js.map